import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
export class MartianChessScoreHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const zeroScore = node.gameState.getScoreOf(Player.ZERO);
        const oneScore = node.gameState.getScoreOf(Player.ONE);
        return PlayerNumberTable.ofSingle(zeroScore, oneScore);
    }
}
